<template>
  <section class="settings-system-alerts-list">
    <ul class="settings-system-alerts-list-items">
      <simple-list-item
        v-for="(alert) in list"
        :key="alert.id"
        :item="alert"
      >
        <context-tag :disabled="!alert.active">
          {{ alert.active ? 'Ativo' : 'Inativo' }}
        </context-tag>
      </simple-list-item>

      <context-state
        :state="currentState"
        tag="li"
      >
        <template v-slot:loading>
          Carregando alertas...
        </template>

        <template v-slot:notfound>
          Nenhum alerta encontrado :(
        </template>

        <template v-slot:empty>
          Sem mais alertas
        </template>
      </context-state>
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import PAGINATION from '@sdk/helpers/misc/pagination';

  import ContextState from '@cordel/components/Context/State.vue';
  import ContextTag from '@cordel/components/Context/Tag.vue';

  import SimpleListItem from '@cordel/components/List/Simple.vue';

  import SystemAlertsListNew from './List/New.vue';

  export default {
    name: 'SystemAlertsList',
    components: {
      ContextState,
      ContextTag,

      SimpleListItem,
    },
    data() {
      return {
        nav: {
          action: SystemAlertsListNew,
        },
      };
    },
    computed: {
      ...mapState([
        'systemAlerts',
      ]),

      list() {
        return Object
          .values(this.systemAlerts.list.items)
          .map(alert => ({
            title: alert.name,
            value: alert.id,
            active: alert.active,
            href: this.$router.resolve({
              name: 'settings-system-alerts-update',
              params: {
                id: alert.id,
              },
            }).href,
          }))
          .sort((a, b) => b.id - a.id);
      },
      loading() {
        return this.systemAlerts.list.loading;
      },
      currentState() {
        if (this.loading) {
          return 'loading';
        }

        if (this.error) {
          return 'error';
        }

        if (this.list.length === 0) {
          return 'notfound';
        }

        return 'empty';
      },
    },
    mounted() {
      this.$store.dispatch('systemAlerts/list', {
        per_page: PAGINATION.MAX_PER_PAGE,
      });
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .settings-system-alerts-list-items {
    list-style: none;
    margin-top: var(--cordel-spacing-xl);
  }
</style>
